import React from 'react'
import Spin from './Spin'

type ProgressIndicatorProps = {
  hint?: string | null
  alwaysHint?: boolean
  onClick?: () => void
}

const ProgressIndicator: React.FC<ProgressIndicatorProps> = ({
  hint = null,
  alwaysHint = false,
  onClick = () => {},
}) => {
  return (
    <div className="progress-container" onClick={onClick}>
      <Spin hint={hint} alwaysHint={alwaysHint} />
    </div>
  )
}

export default ProgressIndicator
